import { Deserializable } from '../interfaces';

export class UserProfile implements Deserializable {
  claveTelefono: string | null;
  email: string | null;
  idUsuario: number | null;
  nombre: string | null;
  pais: string | null;
  telefono: string | null;
  tipo: string | null;
  urlFoto: string | null;

  constructor() {
    this.claveTelefono = null;
    this.email = null;
    this.idUsuario = null;
    this.nombre = null;
    this.pais = null;
    this.telefono = null;
    this.tipo = null;
    this.urlFoto = null;
  }

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}
